@if (editType() !== EditType.DELETE) {
  <app-modal
          title="{{ editType() === EditType.CREATE ? 'Create' : 'Edit' }} Preferred Time Off" #modalComponent>
    <div class="text-center">
      <div class="mb-2">Is this a reoccurring preferred time off?</div>
      <button class="btn" [disabled]="editType() === EditType.EDIT"
              [ngClass]="{'btn-secondary': isReoccurring(), 'btn-outline-secondary': !isReoccurring()}"
              (click)="isReoccurring.set(true)">Yes
      </button>
      <button class="btn ms-2" [disabled]="editType() === EditType.EDIT"
              [ngClass]="{'btn-secondary': !isReoccurring(), 'btn-outline-secondary': isReoccurring()}"
              (click)="isReoccurring.set(false)">No
      </button>
      <hr>
    </div>
    <ng-container *ngTemplateOutlet="template; context: {$implicit: modalComponent}"></ng-container>
  </app-modal>
} @if (editType() === EditType.DELETE) {
  <app-modal title="Delete Preferred Time Off" #modalComponent>
    <ng-container *ngTemplateOutlet="template; context: {$implicit: modalComponent}"></ng-container>
  </app-modal>
}

<ng-template #template let-modalComponent>
  @if (isReoccurring()) {
    <app-ongoing-time-off-form
            [editType]="editType()"
            [employeePositionId]="employeePositionId()"
            [startDate]="startDate()"
            [dayOfWeek]="dayOfWeek()"
            [weeklyPreferredTimesOff]="weeklyPreferredTimesOff()"
            [storeWorkingTime]="storeWorkingTime()"
            [weekExists]="weekExists()"
            [modalComponent]="modalComponent">
    </app-ongoing-time-off-form>
  } @if (!isReoccurring()) {
  <app-temporary-time-off-form
          [editType]="editType()"
          [employeePositionId]="employeePositionId()"
          [temporaryPreferredTimeOff]="temporaryPreferredTimeOff()"
          [storeWorkingTime]="storeWorkingTime()"
          [modalComponent]="modalComponent">
  </app-temporary-time-off-form>
}
</ng-template>